"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Slack = /*#__PURE__*/ _interop_require_default(require("./Slack"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SlackPlugin = class SlackPlugin extends _ncplugin.XcWebhookNotificationPlugin {
    getAdapter() {
        return SlackPlugin.notificationAdapter;
    }
    async init(_config) {
        SlackPlugin.notificationAdapter = new _Slack.default();
        await SlackPlugin.notificationAdapter.init();
    }
};
const _default = SlackPlugin;
